module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA/0lEQVRYhe2TPQrCMBiG3yaNg0UcnLp4Ba9RqBcQBwf/rqREcHAouAtewM1L2BtIEUQa46ARFIwY22TpO31DyPfw5om3P8woHIa4XF4BVAAA4NtemFziZiaDNgA0vFNqHSCTQVsCTM3Wn0AtV7NzByqAUiRMzt1m5tWfpvdqm+Ons6U0oEyXAFNfzirAu+nWAX6JcwBjCedpPxKUcFCAsnw8bSVbk3uMGxCScgAhgPAxG+WfJwg/zNYAColzAK2EfDeIBCFcsrtok87KSDRdtA2IazGiGQOgINF08RfrYSTI4z/X8vEoXhZesy7kpeZrOTVrAWCh5m8ATlMBOAe4Ac5CRdy3p7GeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/NB/second_signal_3.png
// module id = DxfC
// module chunks = 1